import { BASE_API_URL } from '@/constant/api'

export const chatRichtextTestCompletionsUrl = `${BASE_API_URL}/chat/richtext/test_completions`

export type TestChatGender = 1 | 2 | 3

export type TestChatHistoryItem = {
  role: 'assistant' | 'user'
  content: string
}

export type TestChatCompletionsReq = {
  tcid?: string
  character_id?: string
  name: string
  description?: string
  opening: string
  background?: string
  gender: TestChatGender
  output_format_config?: string
  conversation_style?: number
  dialog_style?: Array<{ role: 'assistant' | 'user' | 'all'; message: string }>
  history?: TestChatHistoryItem[]
  content: string
}
